import sharedStyles from 'styles/css/SharedStyles.module.scss';
import formStyles from 'styles/css/FormStyles.module.scss';
import ShortHeaderWithBackBtn from 'components/root/partials/header/ShortHeaderWithBackBtn';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import apiRequest from 'utils/apiRequest';
import { LOGIN, USERS_ACTIVATION_POST } from 'apis'; 
import { handleChangeInputLoginPage, handleChangeProfileData, handleChangeToken } from 'reduxx/actions/pages/user/login';
import { handleSetOpenCustomSnackbar } from 'reduxx/actions/snackbar';
import { handleChangeTimerTimePageVerification, handleChangeInputVerificationPage } from "reduxx/actions/pages/user/verification";
import { useEffect } from "react";

const Verify = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { mobile } = useSelector(state => state.login);
    const { code, timerTime, inputClass, errorTxt } = useSelector(state => state.verification);
    const { isBackdropLoading } = useSelector(state => state.allLoaders);


    useEffect(() => {
        handleTimerTime();
    }, [timerTime]);

    let setTimeOut;
    const handleTimerTime = () => {
        if (timerTime > 0)
            setTimeOut = setTimeout(() => {
                if (timerTime > 0) {
                    dispatch(handleChangeTimerTimePageVerification(timerTime - 1));
                } else
                    clearTimeout(setTimeOut);
            }, 1000);
        else {
            if (timerTime !== 0)
                dispatch(handleChangeTimerTimePageVerification(0));
        }
    };


    const handleChangeInputs = (event) => {
        const {name, value} = event.target;
        dispatch(handleChangeInputVerificationPage(name, changeNumberPersianAndArabic(value)));
    };

    const changeNumberPersianAndArabic = (str) => {
        let
            persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
            arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
        if (typeof str === 'string') {
            for (let i = 0; i < 10; i++) {
                str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
            }
        }
        return str;
    }

    const apiLogin = () => {
        if(! isBackdropLoading) {
            apiRequest({
                dispatch,
                endpoint: LOGIN,
                method: 'post',
                data: { mobile },
                token: null,
                successMessage: null,
                onSuccess: (res) => {
                    dispatch(handleChangeTimerTimePageVerification(parseInt(res.timer_time)));
                },
            });
        }
    };

    const handleSubmitFormLogin = (event) => {
        event.preventDefault();

        if(code.length === 0) {
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'لطفا این قسمت را خالی نگذارید!', severity: 'error', vertical: 'top', horizontal: 'right'}));
        }
        else if(code.length !== 4) {
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'کد باید  4 رقم باشد!', severity: 'error', vertical: 'top', horizontal: 'right'}));
        }
        else {
            if(! isBackdropLoading) {
                apiRequest({
                    dispatch,
                    endpoint: USERS_ACTIVATION_POST,
                    method: 'post',
                    data: { mobile, code },
                    token: null,
                    successMessage: null,
                    onSuccess: (res) => {
                        dispatch(handleChangeInputVerificationPage('code', ''));
                        dispatch(handleChangeInputVerificationPage('timerTime', 0));

                        dispatch(handleChangeInputLoginPage('mobile', ''));

                        let userInfo = res.info;
                        userInfo = {...res.info, medicalRecords: res.medicalRecords};
                        dispatch(handleChangeProfileData(userInfo));
                        dispatch(handleChangeToken(res.token));
                    },
                });
            }

        }
    };

    return (
        
        <div className={sharedStyles.container}>

        	<div className={sharedStyles['container-padding']}>
        		<ShortHeaderWithBackBtn />
        		
	            <div className={[formStyles['title-2'], formStyles['text-right']].join(' ')}>کد ارسال شده به شماره {mobile} را وارد کنید</div>
	            <input inputMode="numeric" name="code" value={code} onChange={handleChangeInputs} className={[formStyles['input'], formStyles['code']].join(' ')} placeholder="کد" max-length={4} />
                { timerTime > 0 ?
                    <span className={formStyles['timer-count-down']}>{timerTime} ثانیه  تا ارسال مجدد کد</span>
                :
                    <span className={formStyles['btn-send-code']} onClick={apiLogin}>ارسال مجدد کد</span>
                }
	            <button onClick={handleSubmitFormLogin} className={formStyles.button}>تایید</button>
        	</div>
	            
        </div>

    );
}

export default Verify;